import { createMutationHelper } from '@utils/swr'
import { type WordPressLoginResponse } from '../types/apiResponse'
import { type WpApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<WpApis['get']['wordPressLogin'], WordPressLoginResponse>({
  client: 'wpRelay',
  key: '/dni/mu/user/wp_login_token',
  fetcher: (url, { arg, client }) => {
    return client.get(url, arg)
  },
})

export const useApiWordPressLogin = useMutation
